export default function stringIsTruthy(test) {
    return test && test.trim() !== '';
}
